import BaseState from "Engine/base/states/BaseState";
import GlobalDispatcher from "Engine/events/GlobalDispatcher";

export default class ShowWinState extends BaseState {
    constructor(stateData) {
        super(stateData);

        this.timeout = null;
    }

    addListeners() {
        super.addListeners();
        GlobalDispatcher.add('bigWinContainer:stopState', this.stopNow, this);
    }

    stopNow() {
        if(this.active) {
            this.stop();
        }
    }

}
